import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/article/${comic.id}`}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`group block ${isLarge ? 'col-span-2' : ''}`}
    >
      <div className={`relative overflow-hidden rounded-lg ${isLarge ? 'aspect-[3/4]' : 'aspect-[3/4]'}`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫画网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="text-xs text-background-50 bg-primary-500 px-2 py-1 rounded-full whitespace-nowrap">
            {comic.status}
          </span>
        </div>
        {comic.rating >= 9.5 && (
          <div className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-1 rounded-full font-semibold">
            热门
          </div>
        )}
      </div>
      <div className="mt-3">
        <h3 className={`font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 ${isLarge ? 'text-base' : 'text-sm'}`}>
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="flex items-center gap-0.5 text-xs text-accent-600">
            <i className="ri-star-fill text-xs"></i>
            {comic.rating}
          </span>
          <span className="text-xs text-foreground-400">{comic.views}</span>
        </div>
      </div>
    </Link>
  );
}